import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import classNames from "classnames/bind";
import { DownIcon, LeftIcon } from "../../../components/Icons/Icons";
import axiosClient from "../../../services/axiosClient";
import styles from "./Header.module.css";
import Notification from "./Notification";
import { getMessaging, getToken } from "firebase/messaging";
import { app } from "../../../config/firebaseConfig";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { actions } from "../../../store";
import { LogoVinosoft } from "../../../components/Icons/Logo";
import { Loading, Toast } from "../../../components";
import Avatar from "./Avatar";
import { LANGUAGES } from "../../../utils";
import { useTranslation } from "react-i18next";
import { Select } from "antd";
import axios from "axios";

const cx = classNames.bind(styles);
const Header = () => {
  const navigate = useNavigate();
  const src = localStorage.getItem("avatar")
  const [isShow, setIsShow] = useState(false);
  const [userName, setUserName] = useState();
  const [name, setName] = useState();
  const [avatar, setAvatar] = useState(src);
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext();
  const [currentLang, setCurrentLanguage] = useState(localStorage.getItem('laguage') || 'vi');
  const [showLaguage, setShowLanguage] = useState(false);
  const refBackground = useRef(null);
  const refBackgroundLang = useRef(null);
  const { t, i18n } = useTranslation();

  const handleShowInfo = (e) => {
    setIsShow(!isShow);
  };

  const handleClearToken = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate("/login", {
      replace: true
    });
    window.location.reload()
  }

  const postToken = async () => {
    try {
      const res = await axiosClient.put(`/userManagement/put-change-user-fcm-token/?username=${userName}`, {
        fcm_token: 'None',
      })
      return res
    } catch (error) {
      throw error;
    }
  }

  const clearToken = async (refreshToken) => {
    try {
      const res = await axiosClient.post(`/authenticator/logout`, {
        refresh: refreshToken
      })
      handleClearToken();
      return res;
    } catch (error) {
      throw error;
    }
  }

  const handleLogout = async (e) => {
    const refreshToken = sessionStorage.getItem('refresh')
    try {
      await postToken();
      await clearToken(refreshToken);
    } catch (error) {
      if (error?.response?.status !== 500) {
        handleClearToken()
      } else {
        Toast.open("Đăng xuất không thành công", 'danger')
      }
    }
  };

  useEffect(() => {
    const getUserInfo = async () => {
      setIsLoading(true)
      try {
        const res = await axiosClient.get('/user/get-user-info/');
        if (res && res?.length > 0) {
          res?.forEach((item) => {
            setName(item?.NAME);
            setUserName(item?.USERNAME);
            dispatch(actions.getUserName(item?.USERNAME))
            dispatch(actions.getUserType(item?.USERTYPE_CODE))
            setAvatar(item.AVATAR);
          });
          sessionStorage.setItem("company_code", res[0].COMPANY_CODE)
          localStorage.setItem("avatar", res[0].AVATAR)
        }
        setIsLoading(false);
        return res;
      } catch (e) {
        setIsLoading(false);
      }
    }
    getUserInfo()
  }, []);

  useEffect(() => {
    const handleClickOutClose = (e) => {
      if (e.target === refBackground.current) {
        setIsShow(false);
      }
    }
    document.addEventListener('click', handleClickOutClose);
    return () => { document.removeEventListener('click', handleClickOutClose) }
  }, [refBackground])
  useEffect(() => {
    const handleClickOutClose = (e) => {
      if (e.target === refBackgroundLang.current) {
        setShowLanguage(false);
      }
    }
    document.addEventListener('click', handleClickOutClose);
    return () => { document.removeEventListener('click', handleClickOutClose) }
  }, [refBackgroundLang])

  const handleClickLogo = () => {
    navigate('/')
  }
  const handleShowLanguage = () => {
    setShowLanguage(!showLaguage);
  }
  const handleChangeLanguage = (val) => {
    localStorage.setItem("laguage", val);
    i18n.changeLanguage(val);
    setCurrentLanguage(val);
    setIsShow(false);
    window.location.reload();
  }

  return (
    <header className={cx("header")}>
      <div className={cx("logo")} onClick={handleClickLogo}>
        <LogoVinosoft />
        <p className={cx("name-system")}>{t("header.nameSystem")}</p>
      </div>
      <div className={cx("user")}>
        <Notification />
        <div className={cx("laguage")} onClick={handleShowLanguage}>
          <div className={cx('icon_lang')} >
            {LANGUAGES.find(lg => lg.value === currentLang).flag}
            {LANGUAGES.find(lg => lg.value === currentLang).label}
            <DownIcon />
          </div>
          {showLaguage && (
            <>
              <ul className={cx("list", "list_language")}>
                {LANGUAGES?.map(lang => {
                  return (
                    <li className={cx('item', 'icon_lang')} onClick={() => handleChangeLanguage(lang?.value)}>
                      {lang.flag}
                      {lang.label}
                    </li>
                  )
                })}
              </ul>
              <div className={cx('background-modal')} ref={refBackgroundLang}></div>
            </>
          )}
        </div>
        <div className={cx("avatar")}>
          <Avatar src={avatar} />
        </div>
        <div className={cx("name")}>{name}</div>
        <NavLink onClick={e => handleShowInfo(e)}>
          <DownIcon className={cx("icon")} />
        </NavLink>
      </div>
      {isShow && (
        <div className={cx("info")} >
          <div className={cx('background-modal')} ref={refBackground}></div>
          <ul className={cx("list")}>
            <Link to={"/info-user"} style={{ textDecoration: "none" }}>
              <li className={cx("item")} onClick={handleShowInfo}>{t("header.user")}</li>
            </Link>
            <Link onClick={handleLogout} style={{ textDecoration: "none" }}>
              <li className={cx("item", "logout")}>{t("header.logout")}</li>
            </Link>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;